module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left1",
    attrs: {
      "id": "contentbox"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tec-page-nav"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "after-sales-wfull-left1-head"
  }, [_c('div', {
    staticClass: "terart"
  }, [_c('p', [_vm._v("产品分类")])]), _vm._v(" "), _c('div', {
    staticClass: "terartboto"
  }, [_vm._v("您所在的位置：产品中心 > "), _c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "category tag"
    }
  }, [_vm._v("产品分类")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div1"
    }
  }, [_c('span', [_vm._v("阻燃剂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝（KH-101、KH-101LC）"
    }
  }, [_vm._v("氢氧化铝（KH-101）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝（KH-101、KH-101LC）"
    }
  }, [_vm._v("氢氧化铝（KH-101LC）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁（K-6）"
    }
  }, [_vm._v("氢氧化镁（K-6）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "三氧化二锑"
    }
  }, [_vm._v("三氧化二锑")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "磷氮系阻燃剂"
    }
  }, [_vm._v("磷氮系阻燃剂")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div2"
    }
  }, [_c('span', [_vm._v("橡胶")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "粉末丁腈橡胶"
    }
  }, [_vm._v("粉末丁腈橡胶")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div3"
    }
  }, [_c('span', [_vm._v("加工剂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅酮"
    }
  }, [_vm._v("硅酮")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅油"
    }
  }, [_vm._v("硅油")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抗氧剂"
    }
  }, [_vm._v("抗氧剂")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "紫外线吸收剂"
    }
  }, [_vm._v("紫外线吸收剂")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "钛白粉"
    }
  }, [_vm._v("钛白粉")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7111980a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 202
// module chunks = 1